export enum ValuePropComponentTheme {
  PeanutButter = 'peanut-butter',
  Avocado = 'avocado',
}

export const ANIMATION_BASE_DURATION = 0.3;
export const ANIMATION_EASING = { type: 'easeIn' };

export function getCardAnimation(delay: number) {
  return {
    containerAnimation: {
      hidden: { opacity: 0, y: '80px' },
      show: {
        opacity: 1,
        y: 0,
        transition: {
          ...ANIMATION_EASING,
          delayChildren: delay,
          staggerChildren: 0.05,
        },
      },
    },
    cardAnimation: {
      hidden: { opacity: 0, y: '80px' },
      show: {
        opacity: 1,
        y: 0,
        transition: {
          ...ANIMATION_EASING,
        },
      },
    },
  };
}
